import axios from "axios";
const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

export async function getBannerData(email) {
    // axios.defaults.withCredentials = true;
    try {
        // const response = await axios.get(`https://ekaminc.com/multiradio/apis/api.php?set=Banner&uid=1 `);
        const response = await axios.get(`${apiBaseUrl}/api.php?set=Banner `);

        return response;
    } catch (error) {
        throw error;
    }
}

